package com.essntl.features.address.ui

import com.essntl.features.address.domain.model.AddressModel

interface AddressEvent {
    data class GetAddress(val id: String) : AddressEvent
    data class UpdateAddressFields(val address: AddressModel) : AddressEvent
    data object AddAddress : AddressEvent
    data object EditAddress : AddressEvent
    data object Clear : AddressEvent
    data object ClearSuccessState : AddressEvent
}